module.exports = __webpack_public_path__ + "static/media/r4.8dd470c5.png";